import { z } from "zod";

function nullableTextInput() {
  return z.string().trim().nullish();
}

export function nullableTextField() {
  return {
    create: nullableTextInput().transform((value) => value || null),
    update: nullableTextInput().transform((value) =>
      value === undefined ? undefined : value || null,
    ),
  } as const;
}
